import { Amplify } from "aws-amplify";
import {
    autoSignIn,
    confirmResetPassword,
    type ConfirmResetPasswordInput,
    confirmSignIn,
    type ConfirmSignInInput,
    confirmSignUp,
    type ConfirmSignUpInput,
    fetchAuthSession,
    fetchUserAttributes,
    getCurrentUser,
    resendSignUpCode,
    resetPassword,
    signIn,
    signInWithRedirect,
    signOut,
    signUp,
    type SignUpInput,
    updatePassword,
    type UpdatePasswordInput,
} from "aws-amplify/auth";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";

import { AuthProviderType } from "../../types/enum/enum";
import awsConfig from "./awsConfig";

// eslint-disable-next-line no-console
console.log("awsConfig", awsConfig);
Amplify.configure(awsConfig);

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());

interface IAwsSignup {
    username: string; // username === email in this project
    email: string;
    password: string;
}

export const awsResendSignupCode = async ({ username }: { username: string }) => {
    return await resendSignUpCode({ username });
};
export const awsEmailSignup = async ({ username, password }: SignUpInput) => {
    return await signUp({
        username,
        password,
    });
};

export const awsEmailSignIn = async ({ username, password }: Omit<IAwsSignup, "email">) => {
    return await signIn({
        username,
        password,
    });
};

export const awsGetCurrentUser = async () => {
    return await getCurrentUser();
};

export const currentSession = async () => {
    return (await fetchAuthSession()).tokens ?? null;
};

export const awsAutoSignIn = async () => await autoSignIn();

export const awsResetPassword = async (username: string) => await resetPassword({ username });

//export const awsResendConfirmationCode = async () => {};

export const awsConfirmResetPassword = async ({
    username,
    confirmationCode,
    newPassword,
}: ConfirmResetPasswordInput) => {
    return await confirmResetPassword({ username, confirmationCode, newPassword });
};

export const awsConfirmSignUp = async ({ username, confirmationCode }: ConfirmSignUpInput) => {
    return await confirmSignUp({ username, confirmationCode });
};

// global: true 會撤銷所有裝置的 refresh token;對 OAuth(Cognito Hosted UI)登入的使用者,
// signOut 會一併導向 Hosted UI 的 logout 端點,清掉 amazoncognito.com 的 session cookie。
// 若只呼叫無參數的 signOut(),只會清本地 token,Hosted UI session 仍存活 →
// 下次點社群登入時 Cognito 直接放行,不會重新走授權,使用者無法切換帳號。
export const awsSignOut = async () => await signOut({ global: true });

export const awsConfirmSignIn = async (data: ConfirmSignInInput) => await confirmSignIn(data);

export const awsSocialLogin = async (provider: AuthProviderType) => signInWithRedirect({ provider });

export const awsFetchUserInfo = async () => await fetchUserAttributes();

// 目前重設密碼與忘記密碼採用同個 API
export const awsUpdatePassword = async ({ oldPassword, newPassword }: UpdatePasswordInput) =>
    await updatePassword({ oldPassword, newPassword });
